import React, { FunctionComponent } from 'react'
import { Props } from './props'

const DefaultStyle = {}

export const Panel: FunctionComponent<Props> = ({ style, className, flex, children }) => {
  const _style = style ? {...DefaultStyle, style, flex} : {...DefaultStyle, flex}
  const _className = className ? `flex-panel ${className}` : 'flex-panel'
  return <div className={_className} style={_style}>{ children }</div>
}

export default Panel